import { createContext, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { Add as AddIcon } from '@mui/icons-material'
import { Button } from '@mui/material'
import { ConfigListPageShell } from '@mobileComponents/ConfigListPageShell'

import { AllDisplayRules } from './components/AllDisplayRules/AllDisplayRules'
import { useDisplayRules } from './hooks/useDisplayRules'
import { PageContextType } from './types/types'

export const PageContext = createContext<PageContextType>({} as PageContextType)

export const DisplayRules: FC = () => {
  const { t } = useTranslation()

  const {
    state: { methods, allDisplayRules },
    data: { isAllDisplayRules, objects, isLoadingDisplayRules },
    handlers: { handleDeleteDisplayRule, handleEditDisplayRule, handleCreateDisplayRule },
  } = useDisplayRules()

  const contextValue = {
    displayRulesTables: allDisplayRules,
    isLoadingDisplayRules,
    objects,
    onCreateDisplayRule: handleCreateDisplayRule,
    onEditDisplayRule: handleEditDisplayRule,
    onDeleteDisplayRule: handleDeleteDisplayRule,
  }

  return (
    <PageContext.Provider value={contextValue}>
      <Outlet />
      <ConfigListPageShell
        title={t('pageTitle.displayRules')}
        isVisible={!!isAllDisplayRules}
        actions={
          <Button variant='contained' startIcon={<AddIcon />} onClick={handleCreateDisplayRule}>
            Create
          </Button>
        }
      >
        <AllDisplayRules methods={methods} />
      </ConfigListPageShell>
    </PageContext.Provider>
  )
}

